import { createSlice } from '@reduxjs/toolkit';
import getInitialState, { getInitialServerState } from './initial-state';
export const initialState = { featureSwitches: {}, splitTestGroups: {} };

const slice = createSlice({
    name: 'environment',
    initialState,
    reducers: {
        initialize: (state, { payload }) => {
            return getInitialState(payload);
        },
        initializeServer: (state, { payload }) => {
            return getInitialServerState(payload);
        },
        setEnvironmentHash: (state, { payload }) => {
            state.environmentHash = payload;
        },
        setIsSpaNavigationEnabled: (state, { payload }) => {
            state.isSpaNavigationEnabled = payload;
        }
    }
});

export const {
    initialize,
    initializeServer,
    setEnvironmentHash,
    setIsSpaNavigationEnabled
} = slice.actions;
export const reducer = slice.reducer;
